import TimelineRow from './timeline-row';

/**
 * Timeline 
 * 
 * @param {HTMLElement} $ele
 * @return {void} 
 */
const Timeline = ($ele) => {
  let isActive = false;
  let isEnd = false;
  
  const rowEles = $ele.querySelectorAll('.timeline-row');
  const pointEle = $ele.querySelector('.timeline-point');
  const lineEle = $ele.querySelector('.timeline-line');

  /**
   * Activate the timeline
   * 
   * @return {void}
   */
  const init = () => {
    events();

    rowEles.forEach(TimelineRow);
  }

  /**
   * Events
   * 
   * @return {void}
   */
  const events = () => {
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', onScroll);
  }

  /**
   * Position the point
   * 
   * @return {void}
   */
  const fixPoint = () => {
    const lineRect = lineEle.getBoundingClientRect();
    const left = lineRect.left + lineRect.width / 2;
    const top = window.innerHeight / 2;

    pointEle.style.position = `fixed`;
    pointEle.style.left = `${left}px`;
    pointEle.style.top = `${top}px`;
  }

  /**
   * Remove point position
   * 
   * @return {void}
   */
  const removePointPosition = () => {
    pointEle.style.position = '';
    pointEle.style.left = '';
    pointEle.style.top = '';
  }

  /**
   * Is the center of the page in the timeline
   * 
   * @return {boolean}
   */
  const checkIsActive = () => {
    const rect = $ele.getBoundingClientRect();
    const viewHeight = window.innerHeight;

    return rect.top < viewHeight / 2;
  }

  /**
   * Is the point at the end of the timeline
   * 
   * @return {boolean}
   */
  const checkIsEnd = () => {
    const rect = pointEle.getBoundingClientRect();
    const eleRect = $ele.getBoundingClientRect();

    return rect.bottom > eleRect.bottom;
  }

  /**
   * On scroll handler
   * 
   * @return {void}
   */
  const onScroll = () => {
    const wasActive = isActive;
    isActive = checkIsActive();
    isEnd = checkIsEnd();

    if (isActive !== wasActive) {
      isActive
        ? fixPoint()
        : removePointPosition();
    }

    $ele.classList.toggle('point-end', isEnd);
    $ele.classList.toggle('point-fixed', isActive);
  }

  /**
   * On window resize handler
   * 
   * @return {void}
   */
  const onResize = () => {
    if (isActive) {
      fixPoint();
    }
  }

  init();
}

document.addEventListener('DOMContentLoaded', () => {
  const timelines = document.querySelectorAll('.timeline');
  timelines.forEach(Timeline);
});